import { defineComponent as _defineComponent } from 'vue'
import { HeadingDisplay, Row, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import type {
  ProfitPreview,
  ProfitOptions
} from '@/modules/trade/services/profit';
import { getExternalAssetPath } from '@/modules/common/helpers/assets-resolver';

interface Props {
  profitSubscriptionHeader: ProfitPreview['header'] | ProfitOptions['header'];
  profitSubscriptionPrice: ProfitPreview['price'] | ProfitOptions['price'];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    profitSubscriptionHeader: null,
    profitSubscriptionPrice: null
  },
  setup(__props: any) {

const props = __props as {
  profitSubscriptionHeader: ProfitPreview['header'] | ProfitOptions['header'];
  profitSubscriptionPrice: ProfitPreview['price'] | ProfitOptions['price'];
}



const nelogicaLogo = getExternalAssetPath('brands/nelogica.svg');

return { __sfc: true,props, nelogicaLogo, HeadingDisplay, Row, BaseText, NebraskaColors }
}

})